var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',[_vm._v(" "+_vm._s(_vm.flash_message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }